import React from "react";
import Link from "next/link";
import { BsArrowRight } from "react-icons/bs";
import Head from "next/head";
import Image from "next/image";
import CtaOne from "@components/CTA/CtaOne";
import { BASE_ASSETS_URL } from "@constants/constants";
import { CLMButtonPrimary } from "components/CLM/v3/Buttons";

const calculatorData = [
  {
    id: 1,
    bgColor: "bg-yellow-100",
    head: "Time Card Calculator",
    description:
      "Effortlessly track work hours with our free time card calculator tool. Generate comprehensive daily and weekly time reports",
    link: "/calculators/work-hours-calculator",
    image: `time-card-calculator.png`,
  },
  {
    id: 2,
    bgColor: "bg-green-200",
    head: "Business Days Calculator",
    description:
      "Try our Business Days Calculator now and simplify your workday management. Streamline your work scheduling with our free Business Days Calculator tool.",
    link: "/calculators/business-days-calculator",
    image: `business-days-calculator.png`,
  },
  {
    id: 3,
    bgColor: "bg-indigo-200",
    head: "Tip Calculator",
    description:
      "Tip Calculator simplifies the process and ensures you leave the right amount of gratuity. Try our Tip Calculator today and enjoy hassle-free bill management!",
    link: "/calculators/tip-calculator",
    image: `tip-calculator.png`,
  },
  {
    id: 4,
    bgColor: "bg-red-200",
    head: "Salary Calculator",
    description:
      "Maximize your earning potential with our free Salary Calculator tool. Try our Salary Calculator now and take control of your finances!",
    link: "/calculators/salary-calculator",
    image: `salary-calculator.png`,
  },
  {
    id: 5,
    bgColor: "bg-indigo-100",
    head: "Mileage Calculator",
    description:
      "Track your fuel costs and optimize your travel expenses with our free Mileage Calculator tool. Try our Mileage Calculator today and save money on your next trip!",
    link: "/calculators/mileage-calculator",
    image: `mileage-calculator.png`,
  },
  {
    id: 6,
    bgColor: "bg-green-100",
    head: "Fuel Cost Calculator",
    description:
      "Whether you're planning a road trip or simply want to keep track of your fuel expenses, our Fuel Cost Calculator is the perfect tool.",
    link: "/calculators/fuel-cost-calculator",
    image: `fuel-cost-calculator.png`,
  },
  {
    id: 7,
    bgColor: "bg-lime-100",
    head: "Sales Tax Calculator",
    description:
      "Are you tired of manually calculating sales tax every time you make a purchase? Try it today and see how easy sales tax calculations can be!",
    link: "/calculators/sales-tax-calculator",
    image: `sales-tax-calculator.png`,
  },
  {
    id: 8,
    bgColor: "bg-pink-100",
    head: "Roofing Calculator",
    description:
      "Roofing calculator is a helpful tool designed to simplify the process of determining the roof area.",
    link: "/calculators/roofing-calculator",
    image: `roofing-calculator.png`,
  },
];

const Calculators = () => {
  return (
    <div className="w-full mt-12 md:mt-20">
      <Head>
        <meta charSet="utf-8" />
        <title> Calculators | BoloForms</title>
        <meta
          name="description"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="Boloforms" />
        <meta name="publisher" content="BoloForms " />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link rel="canonical" href="https://www.bolosign.com/calculators/" />

        <meta
          property="og:url"
          content="https://www.bolosign.com/calculators/"
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content=" Calculators | Boloforms" />
        <meta
          property="og:description"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta
          property="og:image"
          content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta
          property="twitter:url"
          content="https://www.bolosign.com/calculators/"
        />
        <meta
          name="twitter:title"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta
          name="twitter:description"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta
          name="twitter:image"
          content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
        />
      </Head>
      {/* <div className="w-full bg-violet-500 py-20 sm:py-32 -translate-y-10"> */}
      {/* <div className="px-4 md:px-8 xxl:px-0">
          <h1 className="text-[30px] md:text-[50px] font-medium text-white text-center mb-[10px] md:mb-[20px]">
            CALCULATORS
          </h1>
          <p className="text-center mx-auto md:w-[50%] font-extralight text-white text-[16px] md:text-[25px]">
            Our website offers a wide range of tools to meet your needs. Unlock
            the power of efficiency with our versatile calculators and simplify
            your daily tasks!
          </p>
        </div> */}
      <div className="max-w-screen-md mx-auto text-center px-4 relative">
        <CtaOne
          heading2="CALCULATORS"
          paragraph="Our website offers a wide range of tools to meet your needs. Unlock the power of efficiency with our versatile calculators and simplify your daily tasks!"
        />
        {/* <div className="w-full bg-gray-200 relative">
          <Image
            src={`${BASE_ASSETS_URL}/v2/calc.png`}
            width={10}
            height={10}
            className={`moveUpObject w-[50px] sm:w-[80px] xl:w-[100px] absolute xl:-top-40 xl:-left-32`}
            alt="hero"
          />
          <Image
            src={`${BASE_ASSETS_URL}/v2/wheel.svg`}
            width={10}
            height={10}
            className={`rotateObject w-[50px] sm:w-[80px] xl:w-[100px] absolute -top-8 xl:-top-20 right-0 xl:-right-32`}
            alt="hero"
          />
        </div> */}
      </div>
      {/* </div> */}
      <div className="grid gap-[20px] grid-cols-1 md:grid-cols-2 xl:grid-cols-3 max-w-screen-xl mx-auto mt-4 md:mt-10 px-4 md:px-8 xxl:px-0">
        {/* {calculatorData.map((data) => {
          return (
            <div
              key={data.id}
              className={`integration-box flex flex-col sm:flex-row items-start gap-[10px] sm:gap-[30px] border border-gray-800 rounded-[5px] bg-white px-4 py-6 xs:p-[30px] ease-in duration-100 ${data.bgColor} cardBorders`}
            >
              <div className=" text-black">
                <h1 className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] text-[16px] sm:text-[30px] grid place-items-center bg-white imageBorders">
                  {data.id}
                </h1>
              </div>
              <div className="flex flex-col gap-6 justify-between items-start h-[100%]">
                <div className="">
                  <div className="heading text-2xl text-black font-semibold">
                    {data.head}
                  </div>
                  <div className="description text-gray-900 mt-[8px] sm:mt-[15px] text-lg">
                    {data.description}
                  </div>
                </div>
                <Link
                  className="fontPrimary flex items-center text-lg font-medium bg-white text-black border-2 border-gray-800 hover:bg-black hover:text-white px-[20px] py-[3px] rounded-[20px] transition-all duration-500"
                  href={data.link}
                >
                  Try It <BsArrowRight />
                </Link>
              </div>
            </div>
          );
        })} */}
        {calculatorData.map((data) => {
          return (
            <div
              key={data.id}
              className={`integration-box flex flex-col border border-gray-300 rounded-xl bg-white ease-in duration-100 `}
            >
              {/* <div className=" text-black">
                <h1 className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] text-[16px] sm:text-[30px] grid place-items-center bg-white imageBorders">
                  {data.id}
                </h1>
              </div> */}
              <div className="bg-cream rounded-xl px-4 py-12 flex items-center justify-center">
                <Image
                  src={`${BASE_ASSETS_URL}/v2/clm/calculators/${data.image}`}
                  // src={require(`assets/calculators/${data.image}`)}
                  alt={data.head}
                  width={150}
                  height={150}
                  className="h-28 w-auto"
                />
              </div>
              <div className="flex flex-col gap-6 justify-between items-start h-[100%] px-4 py-6">
                <div className="">
                  <div className="heading text-2xl text-black font-bold">
                    {data.head}
                  </div>
                  <div className="description text-gray-700 mt-[8px] sm:mt-[10px] text-base font-medium">
                    {data.description}
                  </div>
                </div>
                <div className="flex items-center">
                  <CLMButtonPrimary
                    buttonText="Try It"
                    buttonUrl={data.link}
                    icon={<BsArrowRight />}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Calculators;
